import {
  createOrder,
  retrieveOrder,
  retrieveOrderByReference,
  updateOrder
} from './qliroCheckoutEndpoints'

export const qliroCheckoutApi = {
  createOrder,
  retrieveOrder,
  retrieveOrderByReference,
  updateOrder
}

export * from './utils'
